import { Pos3D } from '@/sdk'
import { axios, URL, Model } from '@/request'
import { computed, ref } from 'vue'
import { main, list, DataSet, DataSetAtom } from './dataset'
import { round } from '@/utils'
import { disabledGuides } from '@/help/guide'

export type Pano = Pos3D & {
  id: string
  label: string
  gis: Pos3D
  raw: Model.Pano
  originId: number
}

export const panos = ref<Pano[]>([])
export const otherPanos = ref(new Map<DataSetAtom, Pano[]>())
export const allPanos = computed(() => [
  ...panos.value,
  ...Array.from(otherPanos.value.values()).flat()
])
const req = async (dataset: DataSetAtom) => {
  const res: Model.Pano[] = await (axios as any).get(URL.getPanos, {
    params: { datasetId: dataset.id }
  })
  const map = (atom, index) => ({
    raw: atom,
    id: atom.id,
    originId: Number(atom.file_id),
    label: (index + 1).toString(),
    x: atom.dataset_floor_location[0],
    y: atom.dataset_floor_location[1],
    z: atom.dataset_floor_location[2],
    gis: atom.gga_location && {
      x: atom.gga_location[0],
      y: atom.gga_location[1],
      z: atom.gga_location[2]
    }
  })
  return res.map(map)
}

export const requestData = async () => {
  const reqs = list.value.map(async dataset => {
    otherPanos.value.set(dataset, await req(dataset))
  })
  await Promise.all(reqs)

  panos.value = otherPanos.value.get(main.value)
  if (panos.value.length === 0) {
    disabledGuides.value = true
  }
}
